var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Button } from 'antd-msb';
import classNames from 'classnames';
import { DownOutlined, HumburgerOutlined } from 'msb-icons-svg/lib/src';
import React, { useState } from 'react';
import { ConfigContext } from '../config-provider';
import Divider from '../divider';
import Drawer from '../drawer';
import { Col, Row } from '../grid';
import useBreakpoint from '../grid/hooks/useBreakpoint';
import Layout from '../layout';
import Menu from '../menu';
import Space from '../space';
const Header = (_a) => {
    var { prefixCls: customizePrefixCls } = _a, props = __rest(_a, ["prefixCls"]);
    const { className, btnActions, avatar, menuItems, position = 'fixed' } = props;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const [openMenu, setOpenMenu] = useState(false);
    const screens = useBreakpoint();
    const prefixCls = getPrefixCls('header-msb', customizePrefixCls);
    const classString = classNames(`${prefixCls}`, {
        [`${prefixCls}-mobile`]: !screens.lg,
    }, {
        [`${prefixCls}-fixed`]: position === 'fixed',
    }, className);
    const toggleMobileMenu = () => {
        setOpenMenu(!openMenu);
    };
    const menus = (React.createElement(Menu, { className: "", mode: screens.lg ? 'horizontal' : 'inline', rootClassName: `${prefixCls}-menu-items`, items: menuItems, expandIcon: React.createElement(DownOutlined, null) }));
    const logo = (React.createElement("div", { className: "logo" },
        React.createElement("a", { href: "/" },
            React.createElement("img", { alt: "logo", src: "https://common-static-files-public.s3.ap-southeast-1.amazonaws.com/design-system/logo_msb.svg" }))));
    return (React.createElement(Layout.Header, { className: classString },
        React.createElement(Row, { justify: "space-between", wrap: false },
            React.createElement(Col, { span: 3 }, logo),
            React.createElement(Col, { span: 21, className: `${prefixCls}-menus` }, screens.lg ? (React.createElement(React.Fragment, null,
                menus,
                btnActions && (React.createElement("div", { className: "space-ml-16" },
                    React.createElement(Space, null, btnActions))),
                avatar && (React.createElement(React.Fragment, null,
                    React.createElement(Divider, { className: `space-mx-24 ${prefixCls}-avatar-divider`, type: "vertical" }),
                    ' ',
                    React.createElement("div", null, avatar))))) : (React.createElement(Button, { icon: React.createElement(HumburgerOutlined, null), className: `${prefixCls}-mobile-humburger`, shape: "circle", onClick: toggleMobileMenu })))),
        React.createElement(Drawer, { width: "100%", title: logo, placement: "left", onClose: toggleMobileMenu, open: openMenu, key: "left", className: classString },
            avatar && React.createElement("div", { className: `space-p-16 ${prefixCls}-mobile-avatar` }, avatar),
            menus,
            btnActions && (React.createElement(React.Fragment, null,
                React.createElement(Divider, null),
                React.createElement("div", { className: `${prefixCls}-mobile-btn-actions` }, btnActions))))));
};
export default Header;
